import { mountRaceList } from './utils/mount-race-list.js';
import { STATE_URL } from './constants.js';

// Board of Equalization: all four seats, in seat order
mountRaceList('ca-boe', STATE_URL, {
  filter: { offices: ['BOE'], sort: 'seat' },
  component: 'result',
  // 'Seat 1' instead of 'Board of Equalization — Seat 1'; the page has a BOE header
  captionField: 'jurisdiction',
}).catch(console.error);
